
import { Button } from 'antd';
import React, { useState, useCallback, MouseEventHandler } from 'react';
import origCopy from "@assets/redesign/icons/copy.svg";
import wlpCopy from "@components/WLP202603/assets/redesign/icons/copy.svg";
import { makeNotifs } from "@utils/makeNotifs";
import { useGlobalNotifs } from "@utils/hooks/useGlobalNotifs";
import { WLP202603 } from "../../config";
import Icon from '@components/global/new/Icon/Icon';


const copyIcon = WLP202603 ? wlpCopy : origCopy;

interface TextFieldWithCopyProps {
  guid: string;
  className?: string;
  style?: React.CSSProperties;
}

const containerStyle: React.CSSProperties = {
  display: 'grid',
  gridTemplateColumns: 'auto 18px',
  alignItems: 'center',
  gap: '3px',
  width: '100%',
  fontWeight: 600,
};

const textStyle: React.CSSProperties = {
  minWidth: 0,
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
};

const buttonStyle: React.CSSProperties = {
  //padding: '4px 12px',
  cursor: 'pointer',
  //whiteSpace: 'nowrap',
};

export const TextFieldWithCopy: React.FC<TextFieldWithCopyProps> = ({
  guid,
  className,
  style,
}) => {

  const { ok } = makeNotifs();
  const { onSuccess } = useGlobalNotifs();

  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(async (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    try {
      await navigator.clipboard.writeText(guid);
      setCopied(true);
      onSuccess(ok.copied);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  }, [guid]);

  return (
    <div
      className={className}
      style={{ ...containerStyle, ...style }}
    >
      <span style={textStyle} title={guid}>
        {guid}
      </span>
      <Icon
        src={copyIcon}
        style={{
          ...buttonStyle,
          width: 14,
          height: 14,
        }}
        onClick={handleCopy}
      />
      {/* <Button
        style={{
          ...buttonStyle,
          ...(copied && {
            background: '#d4edda',
            borderColor: '#c3e6cb',
          }),
        }}
        onClick={handleCopy}
      >
        <Icon
          src={copyIcon}
          className={className}
          style={{ width: 32, height: 32 }}
          onClick={(e) => e.stopPropagation()}
        />
        {copied ? 'Copied!' : 'Copy'}
      </Button> */}
    </div>
  );
};